import { ConfigContext } from '@tcs/create-account/providers/ConfigProvider';
import { useContext } from 'react';

const useConfig = () => {
  return useContext(ConfigContext);
};

export default useConfig;
